module.exports = __webpack_public_path__ + "img/img-vpower-s.d2187675.png";